import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources';

export const defaultNS = 'translation';

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    lng: 'de',
    defaultNS,
    resources,
    returnNull: false,
    returnObjects: false,
    supportedLngs: ['de', 'en', 'fr'],
    nonExplicitSupportedLngs: true,
  });

// biome-ignore lint/style/noDefaultExport: necessary for i18n
export default i18n;
